/** @format */

import React, { FC, useState } from 'react'
import styled from 'styled-components'
import { _$, Card } from '@king-design/react'
import { CustomPageContainer } from 'src/components'
import { useParams } from 'react-router'
import dayjs from 'dayjs'
import RegionBtn from 'src/components/RegionBtn'
import { MonitorSearch } from 'src/components'
import QuickRangeDate, { DateTimeProps } from 'src/components/QuickRangeDate'
import EventList from 'src/containers/MonitorHistoryTactics/AlarmEventList'

const AlarmEventDetail: FC<{ className?: string }> = ({ className }) => {
  const { policyName } = useParams<{ policyName: string }>()
  const [region, setRegion] = useState<string>(localStorage.getItem('systemId'))
  const [dateTime, setDateTime] = useState<DateTimeProps>({
    StartTime: dayjs().subtract(1, 'h').unix(),
    EndTime: dayjs().unix()
  })
  const [query, setQuery] = useState<string>('')

  return (
    <div className={className}>
      <CustomPageContainer showBack title={decodeURIComponent(policyName)}>
        <Card type="none">
          <RegionBtn
            defaultValue={region}
            regionChange={value => {
              setRegion(value)
            }}
          />
          <div className="header">
            <QuickRangeDate
              format="YYYY-MM-DD HH:mm"
              // eslint-disable-next-line no-restricted-syntax -- QuickRangeDate 与组件约定的默认范围
              defautlValue={'近1小时'}
              // eslint-disable-next-line no-restricted-syntax -- QuickRangeDate 与组件约定的默认范围
              quickRange={['近1小时', '近1天', '近3天', '近1周']}
              optionalDateRange={30}
              changeValue={date => {
                setDateTime({
                  StartTime: dayjs(date[0]).unix(),
                  EndTime: dayjs(date[1]).unix()
                })
              }}
            />
            <MonitorSearch
              placeholder={_$('输入实例ID')}
              value={query}
              onChange={value => {
                setQuery(value)
              }}
            />
          </div>
          <EventList
            region={region}
            dateTime={[dateTime.StartTime, dateTime.EndTime]}
            query={query}
            policyName={decodeURIComponent(policyName)}
          />
        </Card>
      </CustomPageContainer>
    </div>
  )
}

export default styled(AlarmEventDetail)`
  .header {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    & > * {
      margin-top: 16px;
    }
    .k-select {
      margin-right: 16px;
    }
  }
`
